export const normalizeDiacriticsToLatin = (text = ""): string => {
	const res = text
		? text
				.toLowerCase()
				// Romanian/Moldovan
				.replace(/ș/g, "s")
				.replace(/ş/g, "s") // Turkish s-cedilla
				.replace(/ț/g, "t")
				.replace(/ţ/g, "t") // older t-cedilla
				.replace(/î/g, "i")
				.replace(/â/g, "a")
				.replace(/ă/g, "a")
				// Turkish
				.replace(/ğ/g, "g")
				.replace(/ü/g, "u")
				.replace(/ö/g, "o")
				.replace(/ç/g, "c")
				.replace(/ı/g, "i")
				// Uppercase Turkish & Romanian (optional, lowercase already applied)
				.replace(/ş/g, "s")
				.replace(/ç/g, "c")
		: "";
	return res;
};

export const cleanSettlementText = (text = ""): string => {
	const stage1 = normalizeDiacriticsToLatin(text);
	const stage2 = stage1.replace(/\b(mun|or|s)\.\s*/g, ""); // remove 'mun.', 'or.', 's.' prefixes
	const stage3 = stage2.replace(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, ""); // remove punctuation (optional)
	const stage4 = stage3.trim();
	return stage4;
};
